import "isotope-layout/dist/isotope.pkgd.min";
import "imagesloaded/imagesloaded.pkgd.js";
import "jquery.browser";

let pageSize = 0;
let currentPage = 1;
let maxPage = 0;
let siteId = "";
let currentCulture = "";
let currentOmraadeId = "-1"; // alle
const maxPageCount = 5;

$(document).ready(() => {
    currentCulture = $('body').data('currentCulture');
    siteId = $('body').data('siteId');
    pageSize = $('#pageSize').val() as number;
    maxPage = $('#maxPages').val() as number;

    configurePaginationHtml(maxPage);
    initGrid(true);

    initPagination(siteId, currentCulture);

    initDropDown();
});

const initDropDown = () => {
    $('#omraaderDropDown').on('change', function () {
        var omraadeId = $('#omraaderDropDown option:selected').val() as string;
        if (omraadeId === currentOmraadeId) {
            return;
        }

        currentOmraadeId = omraadeId;
        currentPage = 1;
        changePage(currentPage, siteId, currentCulture);
    });
}

const initEllipsis = () => {
    ($('.servicemeddelelse-tekst') as any).ellipsis({
        lines: 2,
        ellipClass: 'ellip',
        responsive: true
    });

    ($('.nyhed-info-content') as any).ellipsis({
        lines: 3,
        ellipClass: 'ellip',
        responsive: true
    });
}

const fetchNyheder = (siteId: string, culture: string, pageIndex: number, pageSize: number) => {
    const offset = (pageIndex - 1) * pageSize;
    currentPage = pageIndex;

    $.ajax({
        url: `/umbraco/api/nyheder/getnyheder?siteId=${siteId}&currentCulture=${culture}&offSet=${offset}&take=${pageSize}&omraadeId=${currentOmraadeId}`,
        success: function (result) {
            var html = buildHtml(result.Nyheder);

            if (maxPage != result.PageCount) {
                maxPage = result.PageCount;
                configurePaginationHtml(maxPage);
                initPagination(siteId, culture);
            }

            updatePagination(pageIndex);
            setPaginationActiveState(pageIndex);

            replaceGridElements(html);
            initGrid(false);

            $('html, body').animate({
                scrollTop: 0
            }, 400);
        }
    });
}

const changePaginationToLastPosition = (currentPage: number) => {
    $(($('.pagination .page') as any).get().reverse()).each(function (index: any, element: any) {
        var $this = $(this);
        var btnIndex = $this.data('index');

        if (btnIndex == 1 || btnIndex == 5) {
            return;
        }

        var newIndex = maxPage - index;
        $this.attr('data-page-index', newIndex);
        $this.find('.number').html(newIndex + "");
    });
}

const changePaginationToFirstPosition = (currentPage: number) => {
    $('.pagination .page').each(function (index: any, element: any) {
        var $this = $(this);
        var btnIndex = $this.data('index');

        if (btnIndex == 1 || btnIndex == 5) {
            return;
        }

        var newIndex = index + 1;
        $this.attr('data-page-index', newIndex);
        $this.find('.number').html(newIndex + "");
    });
}

const configurePaginationHtml = (pageCount: number) => {
    var html = "";

    for (var i = 1; i <= pageCount; i++) {
        var pageNumber = i;
        var breakLoop = false;

        if (i == maxPageCount && i < pageCount) {
            pageNumber = pageCount;
            breakLoop = true;
        }

        var className = "";
        if (i == 1) {
            className = "active";
        }

        var pageHtml = 
            `<div class="page ${className}" data-page-index="${pageNumber}" data-index="${i}">
                <p class="number">${pageNumber}</p>
            </div>`;

        html += pageHtml;

        if (breakLoop) {
            break;
        }
    }

    $(".pagination .pages").html(html);
}

const changePaginationPositionToCenter = (currentPage: number) => {
    $('.pagination .page').each(function (index: any, element: any) {
        var $this = $(this);
        var btnIndex = $this.data('index');

        if (btnIndex == 1 || btnIndex == 5) {
            return;
        }

        var newIndex = currentPage + 1;

        if (btnIndex == 3) {
            newIndex = currentPage;
        } else if (btnIndex < 3) {
            newIndex = currentPage - 1;
        }

        $this.attr('data-page-index', newIndex);
        $this.find('.number').html(newIndex + "");
    });
}

const updatePagination = (pageIndex: number) => {
    if (maxPage > 5) {
        if (pageIndex == maxPage) {
            changePaginationToLastPosition(pageIndex);
        } else if (pageIndex <= 3) {
            changePaginationToFirstPosition(pageIndex);
        } else if (pageIndex < (maxPage - 1) && pageIndex > 3) {
            changePaginationPositionToCenter(pageIndex);
        }
    }
}

const initPagination = (siteId: string, culture: string) => {
    $('.pagination .page').off().on('click', function (e: any) {

        let $paginationBtn = $(this); 
        if ($paginationBtn.hasClass('active')) { // do nothing if active page
            return;
        }

        const currentPageIndex = +$(this).attr('data-page-index');

        updatePagination(currentPageIndex);
        
        currentPage = currentPageIndex;

        changePage(currentPageIndex, siteId, culture);
    });

    $('#arrow-right').off().on('click', function (e: any) {
        const newPageIndex = currentPage + 1;
        if (newPageIndex > maxPage) {
            return;
        }

        updatePagination(newPageIndex);

        changePage(newPageIndex, siteId, culture);
    });

    $('#arrow-left').off().on('click', function (e: any) {
        const newPageIndex = currentPage - 1;
        if (newPageIndex < 1) {
            return;
        }

        updatePagination(newPageIndex);

        changePage(newPageIndex, siteId, culture);
    });
};

const setPaginationActiveState = (newPageIndex: number) => {
    $('.pagination .page.active').removeClass('active');
    $(`.pagination .page[data-page-index=${newPageIndex}]`).addClass('active');
}

const changePage = (newPageIndex: number, siteId: string, culture: string) => {
    setPaginationActiveState(newPageIndex);
    fetchNyheder(siteId, culture, newPageIndex, pageSize);
}

const replaceGridElements = (newHtml: any) => {
    let existingElements = $('.grid .grid-item');
    if (existingElements !== null && existingElements !== undefined && existingElements.length > 0) {
        ($('.grid') as any).off('removeComplete').on('removeComplete', function (event: any, removedItems: any) {
            appendToGrid(newHtml);
        });

        ($('.grid') as any).isotope('remove', existingElements);
    } else {
        appendToGrid(newHtml);
    }
}

const appendToGrid = (newHtml: string) => {
    $('#nyhederGrid').append(newHtml);
    let newElements = $('.grid .grid-item');
    ($('.grid') as any).isotope('appended', newElements);

    ($('#nyhederGrid') as any).imagesLoaded().progress(function () {
        ($('.grid') as any).isotope('layout');
    });
}

const initGrid = (initRun: boolean) => {
    ($('.grid') as any).isotope({
        itemSelector: '.grid-item',
        percentPosition: true,
        masonry: {
            columnWidth: ".grid-sizer",
            gutter: '.gutter-sizer'
        }
    });

    if (initRun) {
        fetchNyheder(siteId, currentCulture, 1, pageSize);
    }

    initEllipsis();
}

const buildHtml = (nyheder: any[]) => {
    var nyhederHtml = "";
    const isInternetExplorer = ($ as any).browser.msie;
    const iosVersion = iOSversion();

    for (let nyhed of nyheder) {
        if (nyhed.IsServicemeddelelse) {
            nyhederHtml +=
                `<a href="${nyhed.NyhedUrl}" class="servicemeddelelse grid-item">
                    <div class="servicemeddelelse-content-wrapper">
                        <div class="loudspeaker-wrapper">
                            <svg class="embla-illustration loudspeaker">
                                <use xlink:href="/dist/illustrations/sprite.symbol.svg#loudspeaker-promotion"></use>
                            </svg>
                        </div>
                        <p class="broedtekst">${nyhed.OmraadeNavn}</p>
                        <p class="servicemeddelelse-tekst">${nyhed.Titel}</p>
                        <p class="dato-tekst">${nyhed.DatoDisplayString}</p>
                    </div>
                </a>`;
        } else {
            let pictureHtml = "";
            if (isInternetExplorer || (iosVersion && iosVersion[0] <= 7)) {
                pictureHtml = `<img class="img-responsive" src="${nyhed.CardImageWideUrl}" />`;
            }
            else {
                pictureHtml = `
                        <picture>    
                            <source srcset="${nyhed.CardImageWideUrl}" media="(max-width: 768px)">
                            <img class="img-responsive" srcset="${nyhed.CardImageUrl}">
                        </picture>`;
            }

            nyhederHtml +=
                `<a href="${nyhed.NyhedUrl}" class="nyhed-card grid-item">
                    <div class="nyhed-card-shadow-container">
                        ${pictureHtml}
                        <div class="nyhed-card-content">
                            <p class="broedtekst large">
                                ${nyhed.OmraadeNavn}
                            </p>
                            <p class="nyhed-info-content">
                                ${nyhed.Titel}
                            </p>

                            <div class="nyhed-navigation-container">
                                <div class="nyhed-navigation-wrapper">
                                    <div class="nyhed-adresse overflow-ellipsis">
                                        ${nyhed.DatoDisplayString}
                                    </div>
                                    <div class="card-arrow">
                                        <svg class="embla-icon " aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <use xlink:href="/dist/icons/sprite.symbol.svg#forward"></use>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>`;
        }
    }

    return nyhederHtml;
}

function iOSversion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || '0', 10)];
    }
}


// WEBPACK FOOTER //
// ./Content/scripts/pages/nyheder.ts